const PRECANNED_QUESTIONS = [
  'Why should I care about spirituality?',
  'Is consciousness generated by the brain?',
  'How does Vedanta view suffering?',
  'Does Vedanta promote indifference to social problems?',
];

const normalizedLookup = new Map(
  PRECANNED_QUESTIONS.map((question) => [question.trim().toLowerCase(), question]),
);

export function isPrecannedQuestion(question) {
  return normalizedLookup.has(String(question || '').trim().toLowerCase());
}

export function getPrecannedResponse(question, responsesByQuestion) {
  if (!responsesByQuestion) return null;
  const canonical = normalizedLookup.get(String(question || '').trim().toLowerCase());
  if (!canonical) return null;
  return responsesByQuestion[canonical] || null;
}
